/*
 *
 * !!! DO NOT MODIFY DIRECTLY !!!
 *
 * @generated via scripts/import-icons
 *
 */

import React from 'react'

import { CssVars } from '../../../themes'
import { TextColorOverride } from '../../TextColorOverride'

export function Link16({
  color,
}: {
  color?: React.ComponentProps<typeof TextColorOverride>['color']
}) {
  const node = (
    <svg
      fill="none"
      height="16"
      role="img"
      viewBox="0 0 16 16"
      width="16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 1.25A3.75 3.75 0 0 0 4.25 5v2.25h1.5V5a2.25 2.25 0 0 1 4.5 0v2.25h1.5V5A3.75 3.75 0 0 0 8 1.25ZM4.25 11V8.75h1.5V11a2.25 2.25 0 0 0 4.5 0V8.75h1.5V11a3.75 3.75 0 1 1-7.5 0Z"
        fill={CssVars.textColor}
      />
      <path
        d="M7.333 5.333v5.334h1.334V5.333H7.333Z"
        fill={CssVars.textColor}
      />
    </svg>
  )
  return color ? (
    <TextColorOverride color={color}>
      {({ rootClassName }) => (
        // NOTE(jare): Since the svg node's display is "inline", it can be
        // rendered with a little whitespace around it in certain cases. We
        // wrap it in a flexbox container to remove that whitespace.
        <span className={rootClassName} css={{ display: 'inline-flex' }}>
          {node}
        </span>
      )}
    </TextColorOverride>
  ) : (
    node
  )
}
